export const CREATE_CHANNEL_CONTRACT_PROFILE_SET = 'CREATE_CHANNEL_CONTRACT_PROFILE_SET';
export const CREATE_CHANNEL_CONTRACT_BANNER_SET = 'CREATE_CHANNEL_CONTRACT_BANNER_SET';
export const CREATE_CHANNEL_CONTRACT_USER_NAME_SET = 'CREATE_CHANNEL_CONTRACT_USER_NAME_SET';
export const CREATE_CHANNEL_CONTRACT_CHANNEL_NAME_SET = 'CREATE_CHANNEL_CONTRACT_CHANNEL_NAME_SET';
export const CREATE_CHANNEL_CONTRACT_DESCRIPTION_SET = 'CREATE_CHANNEL_CONTRACT_DESCRIPTION_SET';
